import { IconProps } from "./icon.type";

export function IcSidebarHome({ ...props }: IconProps) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.72168 0.66474C9.20882 -0.284726 11.1466 -0.217137 12.5693 0.867865L18.332 5.26337C19.3829 6.06486 20 7.31088 20 8.63251V15.7624C19.9999 18.1026 18.1029 19.9997 15.7627 19.9997H4.2373L4.01953 19.9938C1.78057 19.8805 6.19135e-05 18.0295 0 15.7624V8.63251C0 7.31088 0.617114 6.06486 1.66797 5.26337L7.43066 0.867865L7.72168 0.66474ZM11.9629 1.66279C10.8035 0.778769 9.19645 0.778769 8.03711 1.66279L2.27441 6.05829C1.4716 6.67061 1 7.62278 1 8.63251V15.7624C1.00006 17.5503 2.44942 18.9997 4.2373 18.9997H15.7627C17.5506 18.9997 18.9999 17.5503 19 15.7624V8.63251C19 7.62278 18.5284 6.67061 17.7256 6.05829L11.9629 1.66279ZM10 6.9997C11.6569 6.9997 13 8.34285 13 9.9997V12.9997C12.9999 14.6565 11.6568 15.9997 10 15.9997C8.34319 15.9997 7.00007 14.6565 7 12.9997V9.9997C7 8.34285 8.34315 6.9997 10 6.9997ZM10 7.9997C8.89543 7.9997 8 8.89513 8 9.9997V12.9997C8.00007 14.1042 8.89547 14.9997 10 14.9997C11.1045 14.9997 11.9999 14.1042 12 12.9997V9.9997C12 8.89513 11.1046 7.9997 10 7.9997Z"
        fill="currentColor"
      />
    </svg>
  );
}
